import { CircularProgress } from "@material-ui/core";
import React from "react";

import { StatusInfoBar } from "../styles";

function InfoBar() {
  return (
    <StatusInfoBar>Agende uma atividade ou arquive esse contato</StatusInfoBar>
  );
}

export default InfoBar;
